import Insured from "./insured";
import Insurer from "./insurer";
import Crop from "./crop";
import ApplicationValue from "./application-value";

class InsuranceApplication {
    offerId: string = "";

    insured: Insured;
    insurer: Insurer;
    crops: Crop[];
    applicationValues: ApplicationValue[];

    constructor() {
        this.insured = new Insured();
        this.insurer = new Insurer();
        this.crops = [];
        this.crops.push(new Crop());
        this.applicationValues = [];
    }
}

export default InsuranceApplication;
